
















































import vue, {PropType} from 'vue';
import VueCropperJs, {VueCropperMethods} from 'vue-cropperjs';

import 'cropperjs/dist/cropper.css';

export type CropperEndFormatTypeType = string | File | Blob | undefined | null;
export type CropperDragModeType = 'crop' | 'move';

interface ComponentData {
  aspectRatio: number;
  cropper: null | VueCropperMethods;
  dragMode: CropperDragModeType;
}

export default vue.extend({
  name: 'ImageResize',

  props: {
    imgSrc: {
      required: false,
      type: [Object, String] as PropType<CropperEndFormatTypeType>,
      default: undefined,
    },
    loading: {
      required: true,
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },

  components: {
    'vue-cropper': VueCropperJs,
  },

  data: (): ComponentData => ({
    aspectRatio: 1,
    cropper: null,
    dragMode: 'move',
  }),

  mounted() {
    //@ts-ignore
    this.cropper = this.$refs.cropper as VueCropperMethods;
  },

  methods: {
    convertDataUrlToBlob(dataUrl: string | undefined): Blob | undefined {
      if (dataUrl === undefined) return dataUrl;

      let byteString = window.atob(dataUrl.split(',')[1]);
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob(
          [ab],
          {type: dataUrl.split(',')[0].split(':')[1].split(';')[0]},
      );
    },
    onUpdateDragMode(newMode: CropperDragModeType): void {
      this.dragMode = newMode;
      this.cropper?.setDragMode(newMode);
    },
    onUpdateZoom(diff: 0.1 | -0.1): void {
      this.cropper?.relativeZoom(diff);
    },
    onValidate(): void {
      this.$emit(
          'save',
          this.convertDataUrlToBlob(this.cropper?.getCroppedCanvas().toDataURL()),
      );
    },
  },
});
